<script>
  import InfoText from "../../InfoText/InfoText.svelte";
  import EventLocation from "../../EventLocation/EventLocation.svelte";
  import OnlineEventLocation from "../../OnlineEventLocation/OnlineEventLocation.svelte";
  import { renderEventDate } from "../../../utility/renderEventDate";
  import Clock from "../../../icons/clock.svg";

  export let end;
  export let eventType;
  export let location;
  export let start;
  export let title;
  export let tagline;
  export let hostName;
  export let loc;
</script>

<article class="c-upcoming-event__item">
  <h3 class="c-upcoming-event__title">{title}</h3>
  {#if hostName}
    <InfoText>{hostName}</InfoText>
    {:else if tagline}
    <InfoText>{tagline}</InfoText>
  {/if}

  <div class="c-upcoming-event__details">
    <div class="c-event-details__detail">
      <span class="c-event-details__icon">
        <Clock width="14" height="14" />
      </span>
      <span>{renderEventDate(start, end, loc)}</span>
    </div>
    {#if eventType === "Digital"}
      <OnlineEventLocation />
    {:else if location?.city}
      <EventLocation city={location.city} />
    {/if}
  </div>
</article>

<style>
  .c-upcoming-event__item {
    text-decoration: none;
    color: var(--neutral-800);
    display: block;
    text-align: left;
  }
  .c-upcoming-event__title {
    margin-bottom: 8px;
    font-size: 18px;
    font-weight: 600;
    margin-top: 0;
  }
  .c-event-details__detail {
    display: flex;
    margin-top: 12px;
  }

  .c-event-details__icon {
    margin-right: 12px;
    display: flex;
    align-items: center;
  }

  .c-upcoming-event__details {
    display: flex;
    flex-wrap: wrap;
    margin-top: 12px;
  }

  .c-upcoming-event__details > :global(*) {
    margin-right: 20px;
  }
</style>
